import { ADD_NOTIFICATION, LayoutActions, LOADING } from "./actions";

import { LayoutState } from "./state";

const initialState: LayoutState = {
    loading: []
};

function addLoading(state: LayoutState, payload: { action: string }) {
    const loading = state.loading.slice();

    loading.push(payload.action);
    return { ...state, loading };
}

function removeLoading(state: LayoutState, payload: { action: string }) {
    const { action } = payload;
    const loading = state.loading.filter((item: string) => {
        return action !== item;
    });

    return { ...state, loading };
}

export function layoutReducer(state = { ...initialState }, action: LayoutActions): LayoutState {
    switch (action.type) {
        case ADD_NOTIFICATION:
            return { ...state, notification: action.payload };

        case LOADING:
            const { isLoading } = action.payload;

            if (isLoading) {
                return addLoading(state, action.payload);
            } else {
                return removeLoading(state, action.payload);
            }

        default:
            return state;
    }
}
